import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/SiteChrome";
import Home from "@/pages/Home";
import ServiceTax from "@/pages/ServiceTax";
import ServiceGcc from "@/pages/ServiceGcc";
import ServiceFamilyOffice from "@/pages/ServiceFamilyOffice";
import Insights from "@/pages/Insights";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Resources from "@/pages/Resources";
import { Privacy, Terms } from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminContent from "@/pages/admin/AdminContent";
import AdminDownloads from "@/pages/admin/AdminDownloads";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services/international-tax-transfer-pricing" element={<ServiceTax />} />
        <Route path="/services/gcc-india-back-office" element={<ServiceGcc />} />
        <Route path="/services/family-office" element={<ServiceFamilyOffice />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminLeads />} />
        <Route path="content" element={<AdminContent />} />
        <Route path="downloads" element={<AdminDownloads />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
